import * as React from 'react';
import { styled } from '@mui/system';

import { CloseButton } from 'components/Buttons';

const StyledCloseButton = styled(CloseButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2),
  zIndex: theme.zIndex.drawer
}));

export function RouteDrawerCloseButton(props) {
  return <StyledCloseButton {...props} />;
}
